import { atom } from "recoil";

export const providerAddModalStore = atom({
	key: "providerAddModalStore",
	default: {
		show: false,
		loaded: true,
		id: null,
		name: null,
		path: null,
		order: null,
		listed: null,
		active: null,
		integrationType: null,
		restrictedCountries: [],
		currency: [],
		fee: null,
		fieldErrors: {},
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
